import React from "react";

// Compact kg | lbs segmented switch. `units` is "metric"|"imperial",
// `onChange` receives the new value (useUnits().setUnits persists it).
export const UnitToggle = ({ units, onChange, testid = "unit-toggle" }) => (
  <span className="inline-flex border border-obsidian-600 rounded-sm overflow-hidden" data-testid={testid}>
    <button
      type="button"
      data-testid={`${testid}-kg`}
      onClick={() => onChange("metric")}
      className={`px-2.5 py-1 text-[10px] uppercase tracking-widest transition-colors ${units !== "imperial" ? "bg-blaze text-white" : "text-zinc-500 hover:text-zinc-200"}`}
    >
      kg
    </button>
    <button
      type="button"
      data-testid={`${testid}-lb`}
      onClick={() => onChange("imperial")}
      className={`px-2.5 py-1 text-[10px] uppercase tracking-widest transition-colors ${units === "imperial" ? "bg-blaze text-white" : "text-zinc-500 hover:text-zinc-200"}`}
    >
      lbs
    </button>
  </span>
);

export default UnitToggle;
